import axios from 'axios';
import { API_BASE_URL } from '../../../config';

export class ClientBankAccountsApi {
  static getClientBankAccounts = (organizationId, params = {}) => {
    return axios.get(
      `${API_BASE_URL}/organizations/${organizationId}/bank-accounts`,
      { params },
    );
  };

  static getClientBankAccountsForForms = (organizationId, params = {}) => {
    return axios.get(
      `${API_BASE_URL}/organizations/${organizationId}/bank-accounts/for-forms`,
      { params },
    );
  };

  static createClientBankAccount = (organizationId, data) => {
    return axios.post(
      `${API_BASE_URL}/organizations/${organizationId}/bank-accounts`,
      data,
    );
  };

  static getClientBankAccount = (organizationId, accountId) => {
    return axios.get(
      `${API_BASE_URL}/organizations/${organizationId}/bank-accounts/${accountId}`,
    );
  };

  static updateClientBankAccount = (organizationId, accountId, data) => {
    return axios.patch(
      `${API_BASE_URL}/organizations/${organizationId}/bank-accounts/${accountId}`,
      data,
    );
  };

  static deleteClientBankAccount = (organizationId, accountId) => {
    return axios.delete(
      `${API_BASE_URL}/organizations/${organizationId}/bank-accounts/${accountId}`,
    );
  };
}
